import { render, staticRenderFns } from "./purchase-plan-list.vue?vue&type=template&id=7715c3c4&scoped=true&"
import script from "./purchase-plan-list.vue?vue&type=script&lang=js&"
export * from "./purchase-plan-list.vue?vue&type=script&lang=js&"
import style0 from "./purchase-plan-list.vue?vue&type=style&index=0&id=7715c3c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7715c3c4",
  null
  
)

export default component.exports